import { createContext, use, type ReactNode } from 'react';
import type { ClienteDaApi } from './api/cliente';
import type { ClienteDeAuth } from './auth';
import type { Config } from './config';

/** O que a camada de dados usa, injetado por contexto e trocado nos testes (constituição II.6). */
export interface Servicos {
  api: ClienteDaApi;
  auth: ClienteDeAuth;
  config: Config;
}

const ContextoDosServicos = createContext<Servicos | null>(null);

export function ProvedorDeServicos({
  servicos,
  children,
}: {
  servicos: Servicos;
  children: ReactNode;
}) {
  return <ContextoDosServicos value={servicos}>{children}</ContextoDosServicos>;
}

function useServicos(): Servicos {
  const servicos = use(ContextoDosServicos);
  if (servicos === null) throw new Error('Fora do ProvedorDeServicos');
  return servicos;
}

/** Só na camada de dados de cada funcionalidade; componentes usam os hooks (docs/02). */
export function useApi(): ClienteDaApi {
  return useServicos().api;
}

/** Só na camada de dados de cada funcionalidade. */
export function useAuth(): ClienteDeAuth {
  return useServicos().auth;
}

/** Configuração de runtime (valores públicos). */
export function useConfig(): Config {
  return useServicos().config;
}
